const SECTION_FILTER_PREFIX = "pariksit.sectionFilter.";

export function sectionKeyFromRecord(record) {
  return `${record.classId || record.className || ""}__${record.sectionId || record.sectionName || ""}`;
}

export function getSectionFilter(uid) {
  if (!uid) return [];
  try {
    return JSON.parse(localStorage.getItem(`${SECTION_FILTER_PREFIX}${uid}`) || "[]");
  } catch {
    return [];
  }
}

export function saveSectionFilter(uid, sectionKeys = []) {
  if (!uid) return;
  const cleanKeys = [...new Set(sectionKeys.filter(Boolean))];
  localStorage.setItem(`${SECTION_FILTER_PREFIX}${uid}`, JSON.stringify(cleanKeys));
}

export function clearSectionFilter(uid) {
  if (!uid) return;
  localStorage.removeItem(`${SECTION_FILTER_PREFIX}${uid}`);
}
